import { CustomCakeData } from './CustomCakeBuilder';
import { useCakePreviewImage } from './useCakePreviewImage';
import CakeDetailsDialog from './CakeDetailsDialog';
import { Shape } from '../../../../store/shape/api/interface';
import { Flavor } from '../../../../store/flavor/api/interface';
import { ToppingsCategoryItem } from '../../../../store/toppingsCategoryItem/api/interface';

interface CakeDetailsDialogWrapperProps {
  cake: CustomCakeData;
  cakeIndex: number;
  open: boolean;
  onClose: () => void;
  onEdit: (index: number, cake: CustomCakeData) => void;
  onRemove: (index: number) => void;
  onQuantityChange: (index: number, newQty: number) => void;
  shapes: Shape[];
  flavors: Flavor[];
  toppingItems: ToppingsCategoryItem[];
}

const CakeDetailsDialogWrapper: React.FC<CakeDetailsDialogWrapperProps> = ({
  cake,
  cakeIndex,
  open,
  onClose,
  onEdit,
  onRemove,
  onQuantityChange,
  shapes,
  flavors,
  toppingItems,
}) => {
  const { previewImage } = useCakePreviewImage({
    cake,
    shapes,
    flavors,
    toppingItems,
  });

  return (
    <CakeDetailsDialog
      open={open}
      cake={cake}
      cakeIndex={cakeIndex}
      onClose={onClose}
      onEdit={onEdit}
      onRemove={onRemove}
      onQuantityChange={onQuantityChange}
      mergedPreviewImage={previewImage}
    />
  );
};

export default CakeDetailsDialogWrapper;

